var ProvadorMath = {
  bodyTypeMultipliers: {
    'magro': { chest: 0.95, length: 1.0 },
    'padrao': { chest: 1.0, length: 1.0 },
    'atletico': { chest: 1.12, length: 0.98 },
    'robusto': { chest: 1.18, length: 1.0 }
  },

  fitStyleAdjustments: {
    'slim': { diffTarget: 4 },
    'regular': { diffTarget: 10 },
    'oversized': { diffTarget: 16 },
    'boxy': { diffTarget: 14 },
    'cropped': { diffTarget: 10 } // Length will be adjusted in logic
  },

  fallbackSizeChart: {
    "P": { width: 54, length: 72 },
    "M": { width: 58, length: 75 },
    "G": { width: 62, length: 78 },
    "GG": { width: 66, length: 81 }
  },

  extractSizeChartFromText: function(text) {
    if (!text) return null;
    const chart = {};
    let found = false;
    
    // Parse ranges (e.g. 66 - 69) to averages
    const parseVal = (v) => {
      if(v.includes('-')) {
        const parts = v.split('-');
        return (parseInt(parts[0].trim(), 10) + parseInt(parts[1].trim(), 10)) / 2;
      }
      return parseInt(v.trim(), 10);
    };

    const regexKV = /(XGG|XG|GG|G|M|PP|P)\s*[-—–:]?\s*(?:Width|Largura|Peito|Chest)\s*:\s*(\d+(?:\s*-\s*\d+)?)\s*(?:cm)?.*?(?:Length|Comprimento|Altura)\s*:\s*(\d+(?:\s*-\s*\d+)?)\s*(?:cm)?/gi;
    const regexTable = /(XGG|XG|GG|G|M|PP|P)\s+(\d+(?:\s*-\s*\d+)?)\s+(\d+(?:\s*-\s*\d+)?)/gi;

    let match;
    while ((match = regexKV.exec(text)) !== null) {
      found = true;
      chart[match[1].toUpperCase()] = { width: parseVal(match[2]), length: parseVal(match[3]) };
    }

    if (!found) {
      while ((match = regexTable.exec(text)) !== null) {
        found = true;
        // In user's table, Length is first, Width is second
        chart[match[1].toUpperCase()] = { length: parseVal(match[2]), width: parseVal(match[3]) };
      }
    }
    
    return found ? chart : null;
  },

  calculateFit: function(weight, height, age, bodyType, fitPreference, config) {
    const bmi = weight / Math.pow(height / 100, 2);
    
    // Smooth base chest formula with slight BMI correction
    let baseChest = (weight * 0.45) + (height * 0.32);
    if (bmi > 30) baseChest *= 1.05;
    else if (bmi < 18.5) baseChest *= 0.95;

    let ageMultiplier = 1.0;
    if (age >= 13 && age <= 17) ageMultiplier = 0.92;
    else if (age >= 18 && age <= 24) ageMultiplier = 0.96;
    else if (age >= 25 && age <= 35) ageMultiplier = 1.00;
    else if (age >= 36 && age <= 50) ageMultiplier = 1.02;
    else if (age > 50) ageMultiplier = 1.04;

    const multipliers = this.bodyTypeMultipliers[bodyType] || this.bodyTypeMultipliers['padrao'];
    const bodyChest = baseChest * ageMultiplier * multipliers.chest;
    
    // 2. Length Calculation
    // Base mais realista streetwear
    let idealLength = height * 0.40;
    
    const isBoxy = config.tags.includes('__fit:boxy');
    const isOversized = config.tags.includes('__fit:oversized');
    const isSuperOversized = config.tags.includes('__fit:superoversized');
    const isCropped = config.tags.includes('__fit:cropped');
    const isLongline = config.tags.includes('__fit:longline');

    if (isOversized) idealLength += 4;
    if (isSuperOversized) idealLength += 6;
    if (isCropped) idealLength -= 3;
    if (isLongline) idealLength += 6;
    idealLength *= multipliers.length;

    // 3. Fit Ease
    const fitEaseOptions = {
      'slim': 6,
      'regular': 12,
      'oversized': 20,
      'baggy': 26,
      'boxy': 20,
      'cropped': 12
    };
    
    let fitEase = fitEaseOptions[fitPreference] || 12;
    const easeTag = config.tags.find(t => t.startsWith('__ease:'));
    if (easeTag) fitEase = parseInt(easeTag.split(':')[1], 10);
    else if (isSuperOversized) fitEase = 30;

    const idealGarmentChest = bodyChest + fitEase;

    // 4. Use provided size chart from Metafields or Fallback
    let sizeChart = config.sizeChart;
    if (!sizeChart || Object.keys(sizeChart).length === 0) {
      sizeChart = this.fallbackSizeChart;
    }

    let bestSize = Object.keys(sizeChart)[0] || "P";
    let bestScore = 999;
    let finalChestDesc = "";
    let finalLengthDesc = "";
    let finalOverall = "";
    let confidenceScore = 0;
    let chestDiffForBest = 0;
    let lengthDiffForBest = 0;

    // Variables already declared above (isBoxy, isOversized, etc)

    for (const [size, measures] of Object.entries(sizeChart)) {
      const shirtChest = measures.width * 2;
      const chestDiff = shirtChest - idealGarmentChest;
      
      const lengthDiff = measures.length - idealLength;

      const chestScore = Math.abs(chestDiff);
      const lengthScore = Math.abs(lengthDiff);

      // Penalize gradually if the shirt is smaller than the person's real body
      let penalty = shirtChest < bodyChest ? Math.abs(shirtChest - bodyChest) * 5 : 0;

      const totalScore = (chestScore * 2.4) + (lengthScore * 1.3) + penalty;

      if (totalScore < bestScore) {
        bestScore = totalScore;
        bestSize = size;
        chestDiffForBest = shirtChest - bodyChest; // Absolute difference for description
        lengthDiffForBest = lengthDiff;

        // Determine descriptions
        if (chestDiffForBest < 4) { finalChestDesc = "Justo/Apertado no tórax"; finalOverall = "Apertado"; }
        else if (chestDiffForBest < 10) { finalChestDesc = "Caimento slim/justo"; finalOverall = "Justo"; }
        else if (chestDiffForBest < 18) { finalChestDesc = "Confortável, caimento ideal"; finalOverall = "Padrão"; }
        else if (chestDiffForBest < 25) { finalChestDesc = "Levemente oversized"; finalOverall = "Oversized"; }
        else { finalChestDesc = "Bastante largo (Baggy)"; finalOverall = "Baggy"; }

        if (isCropped) {
          finalLengthDesc = "Modelagem cropped";
        }
        else if (lengthDiff < -8) {
          finalLengthDesc = "Mais curta no corpo";
        }
        else if (lengthDiff < -3) {
          finalLengthDesc = "Levemente curta";
        }
        else if (lengthDiff <= 4) {
          finalLengthDesc = "Comprimento ideal";
        }
        else if (lengthDiff <= 8) {
          finalLengthDesc = "Levemente alongada";
        }
        else {
          finalLengthDesc = "Bem alongada";
        }
      }
    }

    // Calculate Confidence Score (0 to 100%) - Commercial adjustment
    // To prevent cart abandonment, we scale the drop so the score rarely goes below 68% 
    // even if the fit is mathematically tight.
    let drop = (bestScore / 100) * 35; 
    const maxDrop = 32; // At maximum, we only drop 32% from the perfect 100% (floor 68%)
    if (drop > maxDrop) drop = maxDrop;

    confidenceScore = Math.max(68, 100 - drop);
    if (confidenceScore > 99 && bestScore > 0) confidenceScore = 99; // Cap at 99 unless perfectly matching

    return {
      recommendedSize: bestSize,
      chestDesc: finalChestDesc,
      lengthDesc: finalLengthDesc,
      overallFit: finalOverall,
      confidence: Math.round(confidenceScore),
      metrics: {
        chestWidth: sizeChart[bestSize]?.width || 0,
        chestDiff: chestDiffForBest,
        lengthDiff: lengthDiffForBest
      }
    };
  }
};

window.ProvadorMath = ProvadorMath;
